import { Injectable } from '@angular/core';
import { Channel } from './channel.model';
import { CrudService, RequestParams } from '@ngx-ivengi/crud';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CrudInteractionService } from '@ngx-ivengi/crud';
import { CrudConfig } from '@ngx-ivengi/crud';
import { ErrorMessage, NotificationService, SuccessMessage } from '@ngx-ivengi/notification';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import { ChannelCurrentState } from './channel-current-state';

export interface IBulkUpdateFields {
  registrationDate?: Date;
}

@Injectable()
export class ChannelService extends CrudService<Channel> {
  public entityType = Channel;
  private channelIds$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  public channelIds = this.channelIds$.asObservable();

  constructor(
    config: CrudConfig,
    http: HttpClient,
    interactionService: CrudInteractionService,
    private notificationService: NotificationService
  ) {
    super(config, http, interactionService);
  }

  public getAll(requestParams: RequestParams = null): Observable<Channel[]> {

    return new Observable((observer) => {
      let httpParams = new HttpParams();

      if(requestParams) {
        const params = requestParams.toKeyValueParams();
        for(const key in params) {
          if(params[key]) {
            httpParams = httpParams.append(key, params[key]);
          }
        }
      }

      this.http.get(`${this.getBaseUrl()}`, {params: httpParams, observe: 'response'})
        .map((response: any) => {
          if(response.body) {
            if(response.body.items && response.body.items.length > 0) {
              response.body.items = response.body.items.map((data) => {
                const channel = new Channel();
                channel.fromResponse(data);
                return channel;
              });
            }

            if(response.body.meta && requestParams) {
              requestParams.pagination.count  = response.body.meta.count;
            }

            if (response.body.meta && response.body.meta.channelIds) {
              this.channelIds$.next(response.body.meta.channelIds);
            }
          }

          return response;
        }).subscribe(
        response => {
          observer.next(response.body.items);
        },
        err => {
          observer.error(err);
        }
      );
    });
  }

  public duplicate(data): Observable<Channel> {
    return new Observable((observer) => {
      this.http.post(`${this.getBaseUrl()}/duplicate`, data, {observe: 'response'}).subscribe(
        response => {
          this.notificationService.notify(new SuccessMessage().setData('channel.duplicate.notification.success'));
          observer.next(<Channel>response.body);
        },
        err => {
          this.notificationService.notify(new ErrorMessage().setData('channel.duplicate.notification.error'));
          observer.error(err);
        }
      );
    });
  }

  public link(data): Observable<Channel> {
    return new Observable((observer) => {
      this.http.post(`${this.getBaseUrl()}/link`, data, {observe: 'response'}).subscribe(
        response => {
          this.notificationService.notify(new SuccessMessage().setData('channel.link.notification.success'));
          observer.next(<Channel>response.body);
        },
        err => {
          this.notificationService.notify(new ErrorMessage().setData('channel.link.notification.error'));
          observer.error(err);
        }
      );
    });
  }

  public terminate(data): Observable<Channel> {
    return new Observable((observer) => {
      this.http.post(`${this.getBaseUrl()}/terminate`, data, {observe: 'response'}).subscribe(
        response => {
          this.notificationService.notify(new SuccessMessage().setData('channel.terminate.notification.success'));
          observer.next(<Channel>response.body);
        },
        err => {
          this.notificationService.notify(new ErrorMessage().setData('channel.terminate.notification.error'));
          observer.error(err);
        }
      );
    });
  }

  public nextLabel(buildingId: string, floorId: string): Observable<string> {
    return this.http.get(`${this.config.getApiUrl()}/building/${buildingId}/floor/${floorId}/label`).map((result: any) => result.nextLabel);
  }

  // private parseErrorBody(errorBody): string {
  //   try {
  //     return JSON.parse(errorBody);
  //   } catch(e) {
  //     return errorBody;
  //   }
  // }

  public bulkUpdate(channelIds: string[], fields: IBulkUpdateFields) {
    return this.http.patch(this.getBaseUrl(), {
      channelIds,
      fields,
    });
  }

  public getCurrentState(channelId: string): Observable<ChannelCurrentState> {
    return this.http.get<ChannelCurrentState>(`${this.getBaseUrl()}/${channelId}/current`);
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/channel/channel.service.ts